export default __webpack_public_path__ + "static/media/datasetLogo.5fd4601f.svg";